import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
      <p>Want to know more?</p>
        <h2>Contact</h2>
      </header>
      <div className="contacts">
        <div>
        <a href="mailto:abdulfarith@ewinlabs.com"><img src={emailIcon} alt="Email" /></a> 
          <a href="mailto:abdulfarith@ewinlabs.com">abdulfarith@ewinlabs.com</a>
        </div>
        <div>
        <a href="tel:+919788693020"><img src={phoneIcon} alt="Phone No" /></a>
          <a href="tel:+919788693020">(+91) 9788693020</a>
        </div>  
      </div>
      <Form></Form>
    </Container>
  )
}